import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ModalDescriptor } from './types'

export type ModalsSlice = {
  openModal: ModalDescriptor | null
}

export const initialState: ModalsSlice = {
  openModal: null
}

export const modalsSlice = createSlice({
  name: 'modals',
  initialState,
  reducers: {
    openModal: (state, action: PayloadAction<ModalDescriptor | null>) => {
      state.openModal = action.payload
    },
    closeModal: state => {
      state.openModal = null
    }
  }
})

export const modalsReducer = modalsSlice.reducer
export const modalsActions = modalsSlice.actions
